import { render } from "./ExtensionTypeView.vue?vue&type=template&id=16e02b9c&scoped=true&ts=true"
import script from "./ExtensionTypeView.vue?vue&type=script&lang=ts"
export * from "./ExtensionTypeView.vue?vue&type=script&lang=ts"

import "./ExtensionTypeView.vue?vue&type=style&index=0&id=16e02b9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e02b9c"]])

export default __exports__